/**
 * Route for `invoice-status-draft-sent-paid-overdue`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvoiceStatusDraftSentPaidOverduePage } from "../features/invoice-status-draft-sent-paid-overdue/InvoiceStatusDraftSentPaidOverduePage";

export const invoiceStatusDraftSentPaidOverdueRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invoice-status-draft-sent-paid-overdue",
	component: InvoiceStatusDraftSentPaidOverduePage,
});

export default invoiceStatusDraftSentPaidOverdueRoute;
